<template>
    <div class="home">
      <div class="top-white-box"></div>
      <div class="top-gray-box">
        <h1>{{settings.blogTitle}}</h1>
      </div>
      <GiveawayBox />
      
      <div class="blog-post-wrapper" v-if="blogPost">
        <div v-for="(content, index) in blogPost.content" :key="index">
            <BlogContent :content="content" />        
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import GiveawayBox from '@/components/GiveawayBox.vue'
import BlogContent from '@/components/BlogContent.vue'
import settings from '@/settings'
import api from '@/api'
import { Article } from '@/classes/Articles'

interface BlogPost extends Article {
  content: any[] // Using any since we don't have the exact content type
}

export default defineComponent({
  name: 'blog',
  components: {
    GiveawayBox,
    BlogContent
  },
  setup() {
    const route = useRoute()
    const slug = ref('')
    const blogPost = ref<BlogPost | null>(null)

    const settingsComputed = computed(() => settings)

    onMounted(async () => {
      document.title = settings.siteNameCaps + ' | ' + settings.siteNameCaps + ' Blog. Read all about deals on our product oriented blog.';
      
      //the url will be /blog/slug
      slug.value = route.params.slug as string;

      //GET BLOG POSTS
      const response = await api.getBlogPost(slug.value);
      blogPost.value = response.data;
    })

    return {
      slug,
      blogPost,
      settings: settingsComputed
    }
  }
})
</script>

<style scoped>
</style>